import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-682c7fb4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "kbd-shift-letter",
  "aria-hidden": "true"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("kbd", {
  class: "kbd-shift-letter__shift",
  title: "Shift"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "kbd-shift-letter__svg",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    "aria-hidden": "true"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M69.973333 461.056l-5.12 5.717333a46.933333 46.933333 0 0 0 37.546667 75.093334h149.248l0.085333 328.533333c0 25.941333 20.992 46.933333 46.933334 46.933333h426.666666l7.68-0.597333a46.933333 46.933333 0 0 0 39.253334-46.336l-0.085334-328.533333H921.6a46.933333 46.933333 0 0 0 32.426667-80.810667l-409.6-392.533333a46.933333 46.933333 0 0 0-64.853334 0l-409.6 392.533333zM512 167.424L804.778667 448H725.333333l-7.68 0.597333a46.933333 46.933333 0 0 0-39.253333 46.336v328.533334h-332.8V494.933333l-0.597333-7.68a46.933333 46.933333 0 0 0-46.336-39.253333h-79.530667L512 167.424z",
      fill: "currentColor"
    })
  ])
], -1))
const _hoisted_3 = {
  key: 0,
  class: "kbd-shift-letter__plus",
  "aria-hidden": "true"
}
const _hoisted_4 = { class: "kbd-shift-letter__key" }


export default /*#__PURE__*/_defineComponent({
  __name: 'kbd-shift-letter',
  props: {
    letter: {},
    showPlus: { type: Boolean, default: false }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    _hoisted_2,
    (_ctx.showPlus)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, "+"))
      : _createCommentVNode("", true),
    _createElementVNode("kbd", _hoisted_4, _toDisplayString(_ctx.letter), 1)
  ]))
}
}

})